import { fetch as apiFetch, postData, putData, deleteFunction } from "../../../Component/function/FunctionApi"; 

const BASE = "Employee";

export const employeeService = {
  getEmployees: () => apiFetch(BASE),
  getEmployeeById: (id) => apiFetch(`${BASE}/${id}`),
  addEmployee: (data) => postData(BASE, data),
  updateEmployee: (id, data) => putData(`${BASE}/${id}`, data),
  deleteEmployee: (id) => deleteFunction(`${BASE}/${id}`),

  addPayroll: (data) => postData(`${BASE}/payroll`, data),
  getEmployeePayrolls: (employeeId) => apiFetch(`${BASE}/${employeeId}/payrolls`),
};